const state = {
  // 保存商品信息
  GoodsDetail: {
    GoodsID: 0,
    GoodsName: '',
    Price: 0,
    Weight: 0,
    CardTitle: '',
    CardText: '',
    SrcImg: '',
    SalceNum: 0,
    StockNum: 0,
    Standard: '',
    UserGradePrice: 0,
    SpecialDiscount: 0,
    NotAddCart: 0,
    ClientBuyNumMax: 0
  }
}

// getters
const getters = {
  GetGoodsDetail: (state, getters) => {
    return state.GoodsDetail
  }
}

// mutations同步更改使用
const mutations = {
  // 更新用户信息
  SetGoodsDetail (state, newGoodsDetail) {
    state.GoodsDetail = newGoodsDetail
  }
}

// actions异步更改使用
const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/CurrGoodsDetail.js